export class Input {
  constructor(el) {
    this.queue = [];
    this.pausedToggle = false;
    this._touchStart = null;
    this._bound = {
      keydown: (e) => this.onKey(e),
      touchstart: (e) => this.onTouchStart(e),
      touchend: (e) => this.onTouchEnd(e),
    };
    window.addEventListener('keydown', this._bound.keydown);
    el.addEventListener('touchstart', this._bound.touchstart, { passive: true });
    el.addEventListener('touchend', this._bound.touchend, { passive: true });
  }

  destroy(el) {
    window.removeEventListener('keydown', this._bound.keydown);
    el.removeEventListener('touchstart', this._bound.touchstart);
    el.removeEventListener('touchend', this._bound.touchend);
  }

  onKey(e) {
    const k = e.key.toLowerCase();
    if (k === 'arrowleft' || k === 'a') this.queue.push('left');
    else if (k === 'arrowright' || k === 'd') this.queue.push('right');
    else if (k === 'arrowup' || k === 'w' || k === ' ') this.queue.push('jump');
    else if (k === 'arrowdown' || k === 's') this.queue.push('roll');
    else if (k === 'p' || k === 'escape') this.pausedToggle = true;
    else return;
    e.preventDefault();
  }

  onTouchStart(e) {
    const t = e.changedTouches[0];
    this._touchStart = { x: t.clientX, y: t.clientY, t: performance.now() };
  }

  onTouchEnd(e) {
    if (!this._touchStart) return;
    const t = e.changedTouches[0];
    const dx = t.clientX - this._touchStart.x;
    const dy = t.clientY - this._touchStart.y;
    const adx = Math.abs(dx);
    const ady = Math.abs(dy);
    const thr = 28;
    if (Math.max(adx, ady) < thr) {
      this.queue.push('jump');
    } else if (adx > ady) {
      this.queue.push(dx < 0 ? 'left' : 'right');
    } else {
      this.queue.push(dy < 0 ? 'jump' : 'roll');
    }
    this._touchStart = null;
  }

  consume() {
    const q = this.queue;
    this.queue = [];
    return q;
  }

  consumePause() {
    const v = this.pausedToggle;
    this.pausedToggle = false;
    return v;
  }
}
